import { LitElement, html, css, buttonStyles } from '@hh/global.js'

class HHButton extends LitElement {
  static properties = {
    key: {},
    href: { type: String },
    decoration: { type: String },
    spacing: { type: String },
    type: { type: String },
    disabled: {
      type: Boolean,
      reflect: true,
    },
    onclick: {
      type: String,
      attribute: 'custom:click',
    },
  }

  constructor() {
    super()

    this.disabled = false
  }

  onClick(e) {
    if (!this.onclick) {
      return
    }

    this.dispatchEvent(
      new CustomEvent(this.onclick, {
        bubbles: true,
        composed: true,
        detail: {
          key: this.key,
          event: e,
        },
      })
    )
  }

  render() {
    return html`${!this.href
      ? html`<button
          ?disabled="${this.disabled}"
          @click="${this.onClick}"
          type="${this.type || 'button'}"
          value="Submit"
        >
          <slot></slot>
        </button>`
      : html`<a href="${this.href}" @click="${this.onClick}">
          <slot></slot>
        </a>`}`
  }

  static styles = [buttonStyles]
}

customElements.define('hh-button', HHButton)
